import React from 'react'

const NO_RESULTS = () => {
  return (
    <div
      aria-label=' There are no results to display'
      className='subtitle-color2 montserratregular font-12 text-center py-2 min-h-200 d-flex align-items-center justify-content-around'
      tabIndex={0}
    >
      There are no results to display
    </div>
  )
}

export default NO_RESULTS
